import React from 'react';
import { Redirect } from 'react-router-dom';

const Auth = props =>
  props.wallet.isLinked ? props.children : <Redirect to={'/'} />;

export default Auth;
